import {
  CompRef,
  CompStructure,
  DocumentServicesObject,
} from '@wix/document-services-types';
import { ComponentTypes } from '@wix/editor-const';
import { isAppProvisioned } from '../utils';
import {
  HEADER_SYSTEM_SLOT,
  MAX_SPX_DIMENSION,
  SPX_REFERENCE_WIDTH,
} from '../constants';
import { INTERNAL_CONTAINER_COMPONENT_TYPE } from './internalContainer';

export { HEADER_SYSTEM_SLOT };

export const systemHeaderComponentDefinition: CompStructure = {
  componentType: HEADER_SYSTEM_SLOT.compType,
  type: 'Component',
  layouts: {
    containerLayout: {},
    spx: {
      refWidth: SPX_REFERENCE_WIDTH,
      resolverType: 'scale',
    },
    componentLayout: {
      type: 'ComponentLayout',
      width: {
        type: 'maxContent',
      },
      height: {
        type: 'auto',
      },
      minWidth: {
        type: 'spx',
        value: 0,
      },
      minHeight: {
        type: 'spx',
        value: 0,
      },
      maxWidth: {
        type: 'spx',
        value: MAX_SPX_DIMENSION,
      },
      maxHeight: {
        type: 'spx',
        value: MAX_SPX_DIMENSION,
      },
      hidden: false,
    },
    itemLayout: {
      type: 'GridItemLayout',
      gridArea: {
        rowStart: 1,
        rowEnd: 2,
        columnStart: 1,
        columnEnd: 2,
      },
      margins: {
        left: {
          type: 'spx',
          value: 0,
        },
        right: {
          type: 'spx',
          value: 0,
        },
        top: {
          type: 'spx',
          value: 0,
        },
        bottom: {
          type: 'spx',
          value: 0,
        },
      },
      justifySelf: 'center',
      alignSelf: 'center',
    },
    type: 'SingleLayoutData',
  },
  components: [],
};

export const ensureSystemHeaderSlotComponent = async (
  documentServicesAPI: DocumentServicesObject,
): Promise<CompRef | undefined> => {
  if (
    isAppProvisioned(
      documentServicesAPI,
      HEADER_SYSTEM_SLOT.appDefinitionId,
    ) === false
  ) {
    console.warn(
      `System header slot app (${HEADER_SYSTEM_SLOT.appDefinitionId}) is not installed, skipping header plugins auto population`,
    );
    return undefined;
  }

  const siteHeaderRef = documentServicesAPI.components.get.byType(
    ComponentTypes.HeaderSection,
  )[0];

  if (!siteHeaderRef) {
    console.warn(
      'Site header (HeaderSection) not found, skipping header plugins auto population',
    );
    return undefined;
  }

  const internalContainerRef = documentServicesAPI.components
    .getChildren(siteHeaderRef)
    .find(
      (childRef) =>
        documentServicesAPI.components.getType(childRef) ===
        INTERNAL_CONTAINER_COMPONENT_TYPE,
    );

  if (!internalContainerRef) {
    console.warn(
      'Header internal container not found, skipping header plugins auto population',
    );
    return undefined;
  }

  const existingSystemHeaderSlotRef = documentServicesAPI.components
    .getChildren(internalContainerRef)
    .find(
      (childRef) =>
        documentServicesAPI.components.getType(childRef) ===
        HEADER_SYSTEM_SLOT.compType,
    );

  if (existingSystemHeaderSlotRef) {
    return existingSystemHeaderSlotRef;
  }

  const ref = documentServicesAPI.components.add(
    internalContainerRef,
    systemHeaderComponentDefinition,
  );
  await documentServicesAPI.waitForChangesAppliedAsync();
  return ref;
};
